import { listChanges } from './changes';
import { validateEventsArray } from './utils';
export function snapshotChanges(query, events, scheduler) {
    events = validateEventsArray(events);
    return listChanges(query, events, scheduler);
}
//# sourceMappingURL=snapshot-changes.js.map